
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
// import { getStation } from "@/api/api-basic";
import { getStaKvs } from "@/api/oms-operation-service";
@Component
export default class SelectStation extends Vue {
  @Prop({ default: 200 }) private width!: number;
  @Prop({ default: "" }) private pkid!: number | string;
  @Watch("pkid")
  getVisible() {
    this.getStation();
  }
  private stationList: object[] = [];

  private staPkId = "";

  async getStation(): Promise<void> {
    if (this.pkid == "") {
      this.stationList = [];
      this.staPkId = "";
    } else {
      const ret = await getStaKvs({ oprPkId: this.pkid });
      if (ret.status === this.$config.apiStatus) {
        this.stationList = ret.data;
      }
    }
  }

  public selectStation(val: number | string): void {
    this.$emit("change", val);
  }
  mounted() {
    if (this.pkid != "") {
      this.getStation();
    }
  }
}
